module.exports = __webpack_public_path__ + "img/sauna_tent_3.b5f210c0.jpg";